import { render, staticRenderFns } from "./InvestmentSuggestionFlagshipCard.vue?vue&type=template&id=791c2d1e&scoped=true&"
import script from "./InvestmentSuggestionFlagshipCard.vue?vue&type=script&lang=ts&"
export * from "./InvestmentSuggestionFlagshipCard.vue?vue&type=script&lang=ts&"
import style0 from "./InvestmentSuggestionFlagshipCard.vue?vue&type=style&index=0&id=791c2d1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791c2d1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VRow})
